<script setup lang="ts">
interface Props {
  /** 0..1 — answered / total. */
  value: number;
  /** e.g. "1 / 3". */
  label: string;
}

defineProps<Props>();
</script>

<template>
  <q-linear-progress
    style="border-radius: 9px"
    stripe
    color="primary"
    track-color="secondary"
    size="18px"
    :value="value"
  >
    <div class="absolute-full flex flex-center">
      <span
        class="text-ink text-caption q-pa-none"
        style="line-height: 1em"
      >
        {{ label }}
      </span>
    </div>
  </q-linear-progress>
</template>
